import { render, staticRenderFns } from "./PolicyDetail.vue?vue&type=template&id=f64fff6c&scoped=true"
import script from "./PolicyDetail.vue?vue&type=script&lang=js"
export * from "./PolicyDetail.vue?vue&type=script&lang=js"
import style0 from "./PolicyDetail.vue?vue&type=style&index=0&id=f64fff6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64fff6c",
  null
  
)

export default component.exports